module.exports = __webpack_public_path__ + "img/ng_cutline.f6cdfb28.svg";